import React, { useRef, useState } from "react";
// @mui
import { Box, CircularProgress, Grid2 } from "@mui/material";
//styling
import resetPageStyles from "./Reset.module.scss";
import { ArrowBack } from "@mui/icons-material";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import { useLocation, useNavigate } from "react-router-dom";
import { resendSignUpCode } from "aws-amplify/auth";
import CongnitoServices from "../../../../redux/Services/cognitoServices";
import "react-toastify/dist/ReactToastify.css";
import { confirmResetPassword } from "aws-amplify/auth";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";
import { verifyPassword } from "../../../../Utils/utils";

export default function NewReset() {
  const navigate = useNavigate();
  const location = useLocation();
  const [enteredCode, setEnteredCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const inputRefs = useRef([]);

  const handleBackClick = () => {
    if (location.state?.prevPage !== "REGISTER") {
      navigate("/forgot");
    } else {
      navigate("/register");
    }
  };

  const resendOtp = async () => {
    try {
      await resendSignUpCode({ username: location.state.email });
      setEnteredCode("");
      inputRefs.current.forEach((input) => {
        if (input) input.value = "";
      });
      setNewPassword("");
      setError(null);
    } catch (e) {
      setError("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const verifyAccount = async () => {
    setError(null);
    setLoading(true);
    try {
      let cognitoResponse = await CongnitoServices.verifyEmail({
        email: location.state.email,
        verificationCode: enteredCode,
      });
      if (cognitoResponse) {
        navigate("/login");
      } else {
        setError("Verification failed. Please try again.");
      }
    } catch (e) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async () => {
    setLoading(true);
    try {
      await confirmResetPassword({
        username: location.state.email,
        newPassword: newPassword,
        confirmationCode: enteredCode,
      });
      navigate("/login");
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCodeKeyDown = (index, event) => {
    if (event.key === "Backspace" && !enteredCode[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (event.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (event.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleCodeChange = (index, value) => {
    const updatedCode =
      enteredCode.slice(0, index) + value + enteredCode.slice(index + 1);
    setEnteredCode(updatedCode);
    setError(null);
    // Move to the next box automatically if a number is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("Text").replace(/\D/g, "");
    if (pastedValue.length === 6) {
      setEnteredCode(pastedValue);
      pastedValue.split("").forEach((char, index) => {
        if (inputRefs.current[index]) {
          inputRefs.current[index].value = char;
        }
      });
    }
  };

  return (
    <>
      <Grid2 className={resetPageStyles.ResetContainer}>
        <Grid2 className={resetPageStyles.FlexBox}>
          <ArrowBack
            className={resetPageStyles.cursor}
            onClick={handleBackClick}
          />
          <Grid2 className={resetPageStyles.back} onClick={handleBackClick}>
            Back
          </Grid2>
        </Grid2>
        <Grid2 className={resetPageStyles.headerFlexBox}>
          <Grid2 className={resetPageStyles.Header}>Email Verification</Grid2>
          <Grid2>
            <Grid2 className={resetPageStyles.subHeader}>
              Please enter the 6-digit verification code sent to{" "}
              <span className={resetPageStyles.bold}>
                {location.state ? location.state.email : ""}
              </span>
            </Grid2>
            <Grid2 className={resetPageStyles.subHeader}>
              If you haven’t received the email, please check your spam folder
              or click here to
              <span
                className={resetPageStyles?.resend}
                onClick={() => resendOtp()}
              >
                resend
              </span>
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 className={resetPageStyles.InputFlexbox}>
          <Box className={resetPageStyles.verificationContainer}>
            {Array.from({ length: 6 }).map((_, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                value={enteredCode[index] || ""}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  handleCodeChange(index, value);
                }}
                onKeyDown={(e) => handleCodeKeyDown(index, e)}
                onPaste={handlePaste}
                ref={(el) => (inputRefs.current[index] = el)}
                className={resetPageStyles.verificationInput}
              />
            ))}
          </Box>
          {location.state?.prevPage !== "REGISTER" ? (
            <Grid2>
              <CustomInput
                placeholder={"New Password"}
                value={newPassword}
                setValue={(val) => {
                  const value = val.replace(/\s/g, "");
                  setNewPassword(value);
                  verifyPassword(val);
                }}
                password={true}
                passwordview={true}
              />
              <Grid2 className={resetPageStyles.error}>{error}</Grid2>
            </Grid2>
          ) : (
            ""
          )}
        </Grid2>

        <CustomButton
          className={resetPageStyles.VerifyAccount}
          onClick={() => {
            if (location.state?.prevPage !== "REGISTER") {
              resetPassword();
            } else {
              verifyAccount();
            }
          }}
          disabled={
            location.state?.prevPage !== "REGISTER"
              ? !verifyPassword(newPassword)
              : enteredCode.length <= 5
          }
        >
          {loading ? (
            <CircularProgress size={25} color={"inherit"} />
          ) : location.state?.prevPage !== "REGISTER" ? (
            "Verify and Reset Password"
          ) : (
            " Verify Account"
          )}
        </CustomButton>
      </Grid2>
    </>
  );
}
